import { GET } from './Clients';

const FRONTEND_APIS_PREFIX = '/marketplace/frontend-apis/v2';
const MARKETING_API_PREFIX = '/marketplace/marketing/v1';

export async function getListHashtagSearch({ ctx, isBasic = false } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/hashtag-searches`,
    isBasic,
  });
}

export async function getCountdownBarList({ ctx, isBasic = true } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/countdownbars`,
    isBasic,
  });
}

export async function getMetaThumbnailList({ ctx, isBasic = true } = {}) {
  return GET({
    ctx,
    url: `${MARKETING_API_PREFIX}/meta-thumbnail/list`,
    isBasic,
  });
}

export async function getMenuBar({ ctx, isBasic = true } = {}) {
  return GET({
    ctx,
    url: `${MARKETING_API_PREFIX}/menu-bar`,
    isBasic,
  });
}

export async function getInsiderSetting({ ctx, isBasic = true } = {}) {
  return GET({
    ctx,
    url: `${MARKETING_API_PREFIX}/insider-setting`,
    isBasic,
  });
}

export async function getChatSetting({ ctx, isBasic = true } = {}) {
  return GET({
    ctx,
    url: `${MARKETING_API_PREFIX}/setting?key=chat_config`,
    isBasic,
  });
}

// Qua frontend-apis: banner đã được lọc theo khách hàng ở đó, web không lọc lại.
export async function getListBanner(ctx) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/banners`,
  });
}

export async function getBannerNano({ ctx, params } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/banners`,
    params,
  });
}

export async function getCampaignList({ ctx, params } = {}) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/campaign-boxes`,
    params,
  });
}

export async function getCampaignListV2(params) {
  return GET({
    url: `${FRONTEND_APIS_PREFIX}/campaign-boxes`,
    params,
  });
}

export async function getProductPriceVolatility({ q = {}, regionCode, offset = 0, limit = 1000, getTotal }) {
  return GET({
    url: `${FRONTEND_APIS_PREFIX}/sku/price-volatility/list`,
    params: { q: JSON.stringify(q), offset, limit, regionCode, getTotal },
  });
}

export async function getCustomerMiniBannerList({ ctx, q = {}, offset = 0, limit = 300, isBasic = false }) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/mini-banners`,
    params: { q: JSON.stringify(q), offset, limit },
    isBasic,
  });
}

export async function getTagBannerList({ ctx, q = {}, isBasic = false }) {
  return GET({
    ctx,
    url: `${FRONTEND_APIS_PREFIX}/tag-banners`,
    params: { q: JSON.stringify(q) },
    isBasic,
  });
}

export async function getMegaBlockProductConfig({ q = {}, getUsing }) {
  return GET({
    url: `${FRONTEND_APIS_PREFIX}/product-mega-blocks`,
    params: { q: JSON.stringify(q), getUsing },
  });
}

export async function getCategoryFilterTree() {
  return GET({ url: `${MARKETING_API_PREFIX}/categories/filter-tree` });
}
